// extracted by mini-css-extract-plugin
export const contentWrapper = "confirmation-page-module--content-wrapper--K1VL0";
export const contentBackground = "confirmation-page-module--content-background--2sZ0Q";
export const primaryContent = "confirmation-page-module--primary-content--J9Qv6";
export const checkmarkWrapper = "confirmation-page-module--checkmark-wrapper--xWduB";
export const primaryTitle = "confirmation-page-module--primary-title--3x96k";
export const primarySubtitle = "confirmation-page-module--primary-subtitle--2KMkc";
export const secondaryContent = "confirmation-page-module--secondary-content--1D9-f";